export default "__VITE_ASSET__DikY1Rz___"